const formatFileSize = (bytes: number): string => {
	// Format a file size in bytes to a human-readable string.
	if (bytes < 1024) {
		return bytes + ' B';
	}
	if (bytes < 1024 * 1024) {
		return (bytes / 1024).toFixed(1) + ' KB';
	}
	return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
};

export { formatFileSize };
